import Reflux from 'reflux';
import actions from '../actions';

export default Reflux.createStore({
	listenables: actions,

	init() {
		this.state = {
			l: {},
			languageCode: 'en',
			apiUrl: null,
			region: 'int',
			showDisabled: false,

			// items: {
			facetRequirements: {},
			visibleFacets: [],
			reducedFacets: [],
			preselection: {},
			defaultUserSelection: {},
			automaticUserSelection: {},
			compositions: [30, 31],
			// },

			accessories: {
				facetRequirements: {},
				preselection: {},
				reducedFacets: [],
				visibleFacets: [],
				defaultUserSelection: {},
				automaticUserSelection: {},
				compositions: [30, 31]
			}
		};
	},

	onChangeConfiguration(state) {
		//state.items = Object.assign(this.state.items, state.items);
		state.accessories = Object.assign(this.state.accessories, state.accessories || {});
		Object.assign(this.state, state);
		this.output();
	},

	getLocalization(key) {
		return this.state.l[key] || key || '';
	},
	getLanguageCode() {
		return this.state.languageCode;
	},
	getRegion() {
		return this.state.region;
	},
	getShowDisabled() {
		return this.state.showDisabled;
	},
	getApiUrl() {
		return this.state.apiUrl;
	},

	tpl(str, data) {
		return str.replace(/\{\{(.*?)\}\}/g, (match, token) => {
			if (data[token] !== null && typeof data[token] !== 'undefined') {
				return data[token];
			}
			return match;
		});
	},

	getState() {
		return this.state;
	},

	output() {
		this.trigger(this.getState());
	},

	getInitialState() {
		return this.getState();
	}
});
